/**
 * partnerFunnels.js — воронки (доски) партнёрской CRM и их колонки.
 *
 * Вынесено из partnerCrm.js: тот упёрся в baseline размера файла (гейт
 * check_component_size), а настройка досок — самостоятельная область: воронка
 * и её колонки правятся только руководителем партнёрки, отдельными правами и
 * своими инвариантами (системную стадию нельзя удалить, непустую — тоже).
 */
import { apiFetch } from './core'

const BASE = '/partner-crm'

export const partnerFunnels = {
    // Воронки (доски YouGile) — несколько на организацию.
    list: () => apiFetch(`${BASE}/funnels`),
    create: (data) =>
        apiFetch(`${BASE}/funnels`, { method: 'POST', body: JSON.stringify(data) }),
    patch: (funnelId, data) =>
        apiFetch(`${BASE}/funnels/${funnelId}`, { method: 'PATCH', body: JSON.stringify(data) }),
    remove: (funnelId) =>
        apiFetch(`${BASE}/funnels/${funnelId}`, { method: 'DELETE' }),

    // Колонки воронки (ярлык/цвет/порядок). funnelId — стадии одной воронки.
    listStages: (funnelId) =>
        apiFetch(funnelId ? `${BASE}/funnel-stages?funnel_id=${funnelId}` : `${BASE}/funnel-stages`),
    // Код колонки выдаёт сервер: Partner.funnel_stage хранит код глобально по
    // организации, поэтому осмысленный код из двух воронок склеил бы карточки.
    createStage: ({ funnelId, label, color }) =>
        apiFetch(`${BASE}/funnel-stages`, {
            method: 'POST',
            body: JSON.stringify({ funnel_id: funnelId, label, color: color || null }),
        }),
    patchStage: (stageId, data) =>
        apiFetch(`${BASE}/funnel-stages/${stageId}`, {
            method: 'PATCH',
            body: JSON.stringify(data),
        }),
    reorderStages: ({ funnelId, stageIds, expectedStageIds }) =>
        apiFetch(`${BASE}/funnel-stages/order`, {
            method: 'PUT',
            body: JSON.stringify({
                funnel_id: funnelId, stage_ids: stageIds, expected_stage_ids: expectedStageIds,
            }),
        }),
    removeStage: (stageId) =>
        apiFetch(`${BASE}/funnel-stages/${stageId}`, { method: 'DELETE' }),

    // Процессы карточки: на каких досках она стоит и на каком этапе в каждой.
    // Раньше доска у карточки была одна (Partner.funnel_stage), и партнёра,
    // которого ведут и в «Привлечении», и в «Развитии», приходилось заводить
    // второй карточкой — история дел и сделок расходилась по двум номерам.
    listMemberships: (partnerId) =>
        apiFetch(`${BASE}/partners/${partnerId}/funnel-memberships`),
    // Поставить ДЕЙСТВУЮЩЕГО партнёра на доску. stageCode пустой — сервер кладёт
    // карточку в первую активную колонку этой доски.
    addPartnerToFunnel: (funnelId, { partnerId, stageCode = null, managerId = null }) =>
        apiFetch(`${BASE}/funnels/${funnelId}/partners`, {
            method: 'POST',
            body: JSON.stringify({
                partner_id: partnerId,
                stage_code: stageCode || null,
                manager_id: managerId || null,
            }),
        }),
    // Сменить этап карточки на ЭТОЙ доске. Основной процесс другой доски и
    // этап карточки (на нём SLA и аналитика) не меняются; основная доска идёт
    // прежним путём с историей переходов. Тело — как у transitionFunnel.
    setStageOnFunnel: (funnelId, partnerId, payload) =>
        apiFetch(`${BASE}/funnels/${funnelId}/partners/${partnerId}/stage`, {
            method: 'PATCH',
            body: JSON.stringify(payload),
        }),
    reassignMembershipManager: (partnerId, membershipId, managerId) =>
        apiFetch(`${BASE}/partners/${partnerId}/funnel-memberships/${membershipId}/manager`, {
            method: 'PATCH',
            body: JSON.stringify({ manager_id: managerId }),
        }),
    // Снять карточку с доски. Последнюю сервер снять не даёт (409
    // last_funnel_membership, решение 07.10.2026): без доски карточка теряет
    // выбор этапа и пропадает с досок.
    removeMembership: (partnerId, membershipId) =>
        apiFetch(`${BASE}/partners/${partnerId}/funnel-memberships/${membershipId}`, {
            method: 'DELETE',
        }),
}
